/**
 * 系统管理  角色管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.roleName" placeholder="输入角色名称"></el-input>
      </el-form-item>
      <el-form-item>
      <el-select size="small" v-model="formInline.roleStatus" clearable placeholder="请选择角色状态">
        <el-option v-for="type in roleStatusEnum" :label="type.key" :value="type.value" :key="type.value"></el-option>
      </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="roleName" label="角色名称" width="180">
      </el-table-column>
      <el-table-column sortable prop="systemType" label="系统类型" width="180">
        <template slot-scope="scope">
          <span>{{systemTypeFormate(scope.row.systemType)}}</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="superAdmin" label="账户级别" width="180">
        <template slot-scope="scope">
          <el-tag :type="scope.row.superAdmin === 1 ? 'primary' : 'success'" disable-transitions>{{superAdminFormate(scope.row.superAdmin)}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column sortable prop="roleStatus" label="角色状态" width="180">
        <template slot-scope="scope">
          <el-switch active-color="#13ce66" inactive-color="#ff4949" :active-value="1"  :inactive-value="0" v-model="scope.row.roleStatus" @change="roleStatusChange(scope.$index, scope.row)" ></el-switch>
        </template>
      </el-table-column>
      <el-table-column sortable prop="updateTime" label="修改时间" width="180">
        <template slot-scope="scope">
          <div>{{formatDate(scope.row.createTime)}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
          <el-button size="mini" type="success" @click="menuAccess(scope.$index, scope.row)">菜单权限</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="角色名称" prop="roleName">
          <el-input size="small" v-model="editForm.roleName" auto-complete="off" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select size="small" v-model="editForm.roleStatus" placeholder="请选择状态">
            <el-option v-for="type in roleStatusEnum" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="系统类型">
          <el-select size="small" v-model="editForm.systemType" placeholder="请选择系统类型">
            <el-option v-for="type in systemTypeEnum" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否超级管理员">
          <el-select size="small" v-model="editForm.superAdmin" placeholder="是否超级管理员">
            <el-option v-for="type in superAdminEnum" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
    <!-- 菜单权限 -->
    <el-dialog title="菜单权限" :visible.sync="menuAccessshow" width="30%" @click='closeDialog("perm")'>
      <el-tree ref="tree" default-expand-all="" :data="RoleRight" :props="RoleRightProps" :default-checked-keys="checkmenu" node-key="id" show-checkbox>
      </el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("perm")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="menuPermSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  roleList,
  roleSave,
  roleDelete,
  RoleRightTree,
  changeRoleStatus,
  RoleRightSave
} from '../../api/userMG'
import {formatDate} from '../../utils/util'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      menuAccessshow: false, //控制数据权限显示与隐藏
      title: '添加',
      editForm: {
        roleId: '',
        roleStatus: '',
        roleName: '',
        systemType:'',
        superAdmin:'',
        token: localStorage.getItem('logintoken')
      },
      editStatusForm:{
        roleId: '',
        roleStatus: '',
        token: localStorage.getItem('logintoken')
      },
      roleStatusEnum:[
        { key: '启用', value: 1},
        { key: '禁用', value: 0},
      ],
      systemTypeEnum:[
        { key: '商户平台', value: "mch"},
        { key: '管理平台', value: "manage"},
      ],
      superAdminEnum:[
        { key: '超管角色', value: 1},
        { key: '普通角色', value: 0},
      ],
      // rules 表单验证
      rules: {
        roleStatus: [
          { required: true, message: '请选择状态', trigger: 'blur' }
        ],
        roleName: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ]
      },
      formInline: {
        current: 1,
        size: 10,
        roleName: '',
        roleStatus: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 数据权限
      RoleRight: [],
      RoleRightProps: {
        children: 'children',
        label: 'name'
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  watch: {},

  /**
   * 创建完毕
   */

  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {
    // 获取角色列表
    getdata(parameter) {
      this.loading=true
      roleList(parameter)
        .then(res => {
          this.loading = false
          if (res.code !== '200') {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data.content
            // 分页赋值
            this.pageparm.currentPage = res.data.pages
            this.pageparm.pageSize = 10
            this.pageparm.total = res.data.total
            this.loading=false
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('获取角色列表失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.roleId = row.roleId
        this.editForm.roleStatus = row.roleStatus
        this.editForm.roleName = row.roleName
        this.editForm.superAdmin=row.superAdmin
        this.editForm.systemType=row.systemType
      } else {
        this.title = '添加'
        this.editForm.roleId = ''
        this.editForm.roleStatus = ''
        this.editForm.roleName = ''
        this.editForm.superAdmin=''
        this.editForm.systemType=''
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          roleSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code=='200') {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '角色保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('角色保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除角色
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          roleDelete(row.roleId)
            .then(res => {
              console.info(res)
              if (res.code==='200') {
                this.$message({
                  type: 'success',
                  message: '角色已删除！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('角色删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 数据权限
    menuAccess: function(index, row) {
      this.RoleRight=[];
      this.menuAccessshow = true
      this.saveroleId = row.roleId
      RoleRightTree(row.roleId)
        .then(res => {
          if (res.data.code=='200') {
            this.$message({
              type: 'success',
              message: '获取权限成功'
            })
            this.changemenu(res.data.data)
            this.RoleRight = this.changeArr(res.data.data)
          } else {
            this.$message({
              type: 'info',
              message: res.data.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('获取权限失败，请稍后再试！')
        })
    },
    // 选中菜单
    changemenu(arr) {
      let change = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].checked) {
          change.push(arr[i].id)
        }
      }
      this.checkmenu = change
    },
    // tree 递归
    changeArr(list) {
      var temptree = [],
        tree = [],
        items = []
      for (var i in list) {
        debugger
        if (!temptree[list[i].id]) {
          var trow = {
            id: list[i].id,
            pid: list[i].pid,
            name: list[i].name,
            open: list[i].open,
            checked: list[i].checked,
            children: []
          }
          temptree[list[i].id] = trow
          items.push(trow)
        }
      }
      for (var j in items) {
        if (temptree[items[j].pid]) {
          temptree[items[j].pid]['children'].push(temptree[items[j].id])
        } else {
          tree.push(temptree[items[j].id])
        }
      }
      temptree = null
      items = null
      return tree
    },
    // 菜单权限-保存
    menuPermSave() {
      let parm = {
        roleId: this.saveroleId,
        menuIds: ''
      }
      let node = this.$refs.tree.getCheckedNodes()
      let moduleIds = []
      if (node.length != 0) {
        for (let i = 0; i < node.length; i++) {
          moduleIds.push(node[i].id)
        }
        parm.menuIds = moduleIds
      }
      RoleRightSave(parm)
        .then(res => {
          if (res.code==='200') {
            this.$message({
              type: 'success',
              message: '权限保存成功'
            })
            this.menuAccessshow = false
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.message
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('权限保存失败，请稍后再试！')
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'perm') {
        this.menuAccessshow = false
      }
    },
    roleStatusFormate(itemValue){
      for(let obj of this.roleStatusEnum){
        if(obj.value===itemValue){
          return obj.key;
        }
      }
    },
    systemTypeFormate(itemValue){
      for(let obj of this.systemTypeEnum){
        if(obj.value===itemValue){
          return obj.key;
        }
      }
    },
    superAdminFormate(itemValue){
      for(let obj of this.superAdminEnum){
        if(obj.value===itemValue){
          return obj.key;
        }
      }
    },
    formatDate(timestamp){
      if(timestamp===null){
        return '';
      }
      const dateObj = new Date(timestamp);
      const year = dateObj.getFullYear();
      const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
      const day = ('0' + dateObj.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },
    roleStatusChange(index, row){
      this.editStatusForm.roleId=row.roleId
      this.editStatusForm.roleStatus=row.roleStatus;
      changeRoleStatus(this.editStatusForm)
        .then(res => {
          console.info(res)
          if (res.code=='200') {
            this.$message({
              type: 'success',
              message: '状态已修改！'
            })
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.message
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('修改状态失败，请稍后再试！')
          this.getdata(this.formInline)
        })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/system/Role.vue